import React from "react";
import { Card, Group, Stack, Button } from "@mantine/core";
import { format } from "date-fns";
import { ReactComponent as HomeIcon } from "../../../../assets/icons/home.svg";
import { ReactComponent as LocationIcon } from "../../../../assets/icons/location.svg";
import Title from "../../../../components/Elements/Title/Title";

interface WeAreHiringCardProps {
  item: {
    id: number;
    category: { id: number; name: string };
    title: string;
    created: string;
    site: string;
    location: string;
    linkUrl: string;
  };
}

const WeAreHiringCard: React.FC<WeAreHiringCardProps> = ({ item }) => (
  <Card
    padding="md"
    radius="md"
    withBorder
    className="!rounded-2xl !bg-[#131316] !border-[#2f2f31] gap-4"
  >
    <Group justify="space-between">
      <Title title={item.category.name} className="!mb-0"></Title>
      <div className="text-right text-[#9e9e9f] text-sm font-medium uppercase">
        {format(new Date(item.created), "HH:mm, dd.MM.yyyy.")}
      </div>
    </Group>
    <Group justify="space-between">
      <Stack gap="0.5rem">
        <div className="text-neutral-50 text-base font-bold">{item.title}</div>
        <Group gap="1.5rem">
          <div className="flex items-center gap-2">
            <HomeIcon className="inline" />
            {item.site}
          </div>
          {item.location && (
            <div className="flex items-center gap-2">
              <LocationIcon className="inline" />
              {item.location}
            </div>
          )}
        </Group>
      </Stack>
      {item.linkUrl && (
        <Button
          variant="white"
          color="#030102"
          className="!rounded-lg"
          onClick={() => window.open(item.linkUrl, "_blank")}
        >
          View Job
        </Button>
      )}
    </Group>
  </Card>
);

export default WeAreHiringCard;
